import { create } from "zustand";
import type { OrderEntry } from "../types/trades";

interface OrdersState {
  orders: Map<string, OrderEntry>;
  setSnapshot: (rows: OrderEntry[]) => void;
  applyDelta: (upserts: OrderEntry[], removedIds: string[]) => void;
  clear: () => void;
}

/** Live order book fed by the WS `orders` channel (snapshot + delta), with
 *  REST `/orders` as the initial hydration in the panel. */
export const useOrdersStore = create<OrdersState>((set, get) => ({
  orders: new Map(),
  setSnapshot: (rows) => {
    const m = new Map<string, OrderEntry>();
    for (const r of rows) m.set(r.order_id, r);
    set({ orders: m });
  },
  applyDelta: (upserts, removedIds) => {
    const next = new Map(get().orders);
    for (const id of removedIds) next.delete(id);
    for (const r of upserts) next.set(r.order_id, r);
    set({ orders: next });
  },
  clear: () => set({ orders: new Map() }),
}));

export function selectOrdersArray(state: OrdersState): OrderEntry[] {
  return Array.from(state.orders.values());
}
